import api from "../services/api";

export const setClaimFormActivation = async (packageId, claim_form_activated) => {
  try {
    const response = await api.patch(
      `/package-management/packages/${packageId}/claim-form-activation`,
      null,
      {
        params: { claim_form_activated },
      }
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data.package };
    } else {
      return {
        success: false,
        error: response.data?.message || "Unexpected server response",
      };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to update claim form activation",
    };
  }
};